import { Navigate, useParams } from 'react-router-dom';

export function QuotationProductEditPage() {
  const { quotationId, productId } = useParams();
  return (
    <Navigate
      to={`/quotations/${quotationId}?editProduct=${productId}`}
      replace
    />
  );
}

export default QuotationProductEditPage;
